import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "z-50 fixed top-0 left-0 flex flex-row min-h-screen w-screen" }
const _hoisted_2 = { class: "w-9/12 flex flex-col w-full" }
const _hoisted_3 = { class: "flex flex-row items-center px-6 py-4 border-b-2 border-background-dark border-opacity-70 bg-background-light h-1/6" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"48\" height=\"48\" fill=\"#FDC20B\"></rect><g filter=\"url(#filter0_i)\"><circle cx=\"24\" cy=\"24\" r=\"12\" fill=\"white\"></circle></g><defs><filter id=\"filter0_i\" x=\"12\" y=\"12\" width=\"26\" height=\"26\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"></feBlend><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"></feColorMatrix><feOffset dx=\"2\" dy=\"2\"></feOffset><feGaussianBlur stdDeviation=\"2\"></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\"></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"></feColorMatrix><feBlend mode=\"normal\" in2=\"shape\" result=\"effect1_innerShadow\"></feBlend></filter></defs></svg>", 1)
const _hoisted_5 = { class: "ml-4" }
const _hoisted_6 = { class: "flex justify-between flex-col h-full bg-background-medium pl-6" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "border-t-2 border-background-light flex object-bottom" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.t('title')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menuItem.id,
              class: "flex items-center justify-left border-b-2 border-background-light h-16 cursor-pointer",
              onClick: () => _ctx.openMenuItem(menuItem)
            }, _toDisplayString(menuItem.title), 9, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItemsBottom, (menuItem) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menuItem.id,
              class: "flex items-center justify-left h-16 cursor-pointer",
              onClick: () => _ctx.openMenuItem(menuItem)
            }, _toDisplayString(menuItem.title), 9, _hoisted_9))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "w-3/12 opacity-60 bg-background-medium",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
    })
  ], 512)), [
    [_vShow, _ctx.menuIsVisible]
  ])
}